export enum FlightOfferViewEnum {
  DETAILS = 'DETAILS',
  PAYMENT = 'PAYMENT',
  COMPLETED = 'COMPLETED',
  INVOICE_DETAILS = 'INVOICE_DETAILS',
  INVOICE_DETAILS_EMAIL = 'INVOICE_DETAILS_EMAIL',
}
